import { message } from 'antd';
import { InputOTP } from 'antd-input-otp';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { IAsset } from '../../pages/Wallet/types';
import { TRootState } from '../../store/store';
import { resetBalanceById } from '../../store/wallet/wallet.slice';
import { transport } from '../../utils/constants';
import { getToken, isRpcError, Notification, type } from '../../utils/helper';
import ControlledInput from '../Common/ControlledInput/ControlledInput';
import IosModal from '../Common/IosModal/IosModal';
import OperationFee from './OperationFee';
import './WithDraw.scss';
import { Wallet_Asset } from '../../generated/mlmbox/types/wallet';
import { WalletClient } from '../../generated/mlmbox/client/finance/wallet.client';
import { Status_GoogleAuthenticator, Status_Transaction } from '../../generated/mlmbox/types/status';
import Button from '../Button/Button';

const WithDraw: React.FC<{
    assetId: number;
    closeBtn: Function;
    setReload: Function;
    withDrawProcessingAlow: IAsset | null;
}> = ({ assetId, closeBtn, setReload, withDrawProcessingAlow }) => {
    const navigate = useNavigate();
    const googleAuthenticator = useSelector((state: TRootState) => state.user.value.googleAuthenticator);
    const [showVerifed, setShowVerifed] = useState(false);
    const wallet = useSelector((state: TRootState) => state.wallet.value);
    const [userWallet, setUserWallet] = useState<Wallet_Asset>();
    const [amountValue, setAmountValue] = useState('');
    const [openAmount, setOpenAmount] = useState(false);
    const [openToUser, setOpenToUser] = useState(false);
    const [toUser, setToUser] = useState('');
    const [close, setClose] = useState(false);
    const dispatch = useDispatch();
    const [fetching, setFetching] = useState(false);
    const [opertionFeeFromBody, setOperationFeeFromBody] = useState(false);

    const { t } = useTranslation();

    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    function allow() {
        let result = true;
        if (assetId === 1) {
            if (
                Number(amountValue) > Number(withDrawProcessingAlow?.settingsWithdrawalOperationValueMax) ||
                Number(amountValue) < Number(withDrawProcessingAlow?.settingsWithdrawalOperationValueMin) ||
                (googleAuthenticator.status !== 1 && Number(amountValue) > 1000) ||
                (!opertionFeeFromBody &&
                    googleAuthenticator.status === 1 &&
                    Number(userWallet?.withdrawalCapacity?.available) -
                        (Number(amountValue) +
                            (Number(amountValue) / 100 + Number(withDrawProcessingAlow?.settingsWithdrawalFeeBase))) <
                        0) ||
                Number(userWallet?.withdrawalCapacity?.available) < Number(amountValue) ||
                !toUser
            )
                return (result = false);
        }

        if (assetId === 2) {
            if (
                Number(amountValue) < 30000 ||
                Number(userWallet?.withdrawalCapacity?.available) < Number(amountValue) ||
                !toUser
            )
                return (result = false);
        }

        return result;
    }

    useEffect(() => {
        setUserWallet(wallet.assets.find((el) => el.assetId === assetId));
        assetId === 2 && setOperationFeeFromBody(true);
    }, []);

    function withdraw(code?: string[]) {
        setFetching(true);
        if (googleAuthenticator.status === 1 && !code?.length) return;

        if (!withDrawProcessingAlow) return;

        const walletClient = new WalletClient(transport);

        walletClient
            .withdrawal(
                {
                    address: toUser,
                    operationAmount: {
                        assetId,
                        value: amountValue,
                    },
                    operationFeeFromBody: opertionFeeFromBody,
                    processingId: withDrawProcessingAlow.processingId,
                    verifiedCode: code?.length && showVerifed && googleAuthenticator.status === 1 ? code.join('') : '',
                },
                { meta: { authorization: getToken() } }
            )
            .then(({ status, response }) => {
                if (
                    status.code === 'OK' &&
                    (response.statusId === Status_Transaction.SUCCESS ||
                        response.statusId === Status_Transaction.PROCESSING)
                ) {
                    dispatch(resetBalanceById({ assetId, balance: response.balance }));
                    setReload((prev: boolean) => !prev);
                    closing();
                    Notification(type.success);
                    message.success(t('wallet.withdraw.success'));
                }
            })
            .catch((err) => {
                if (isRpcError(err)) {
                    console.log(err);
                    if (err?.message)
                        switch (err.message) {
                            case 'GOOGLE_AUTHENTICATOR_UNKNOWN':
                                message.error(t('errors.unknown'));
                                setShowVerifed(false);
                                setFetching(false);
                                return;
                            case 'GOOGLE_AUTHENTICATOR_REJECTED':
                                message.error(t('errors.twoFa'));
                                setShowVerifed(false);
                                setFetching(false);
                                return;
                            case 'GOOGLE_AUTHENTICATOR_WRONG_CODE':
                                message.error(t('errors.wrong_code'));
                                setFetching(false);
                                return;
                            case 'RESOURCE_EXHAUSTED':
                                message.error('Превышено максимальное количество попыток');
                                setShowVerifed(false);
                                setFetching(false);
                                return;
                            case 'ACCESS_TOKEN_PERMISSION_DENIED':
                                message.error('Недостаточно прав');
                                setShowVerifed(false);
                                setFetching(false);
                                return;
                            case 'PROCESSING_UNKNOWN':
                                message.error('Не верный процесс');
                                setShowVerifed(false);
                                setFetching(false);
                                return;
                            case 'PROCESSING_NOT_FOUND':
                                message.error('Процесс не нашелся');
                                setShowVerifed(false);
                                setFetching(false);
                                return;
                            case ' PROCESSING_NOT_AVAILABLE':
                                message.error('Процесс не доступен');
                                setShowVerifed(false);
                                setFetching(false);
                                return;
                            case 'PROCESSING_ADDRESS_UNKNOWN':
                                message.error('Адрес не указан');
                                setShowVerifed(false);
                                setFetching(false);
                                return;
                            case 'PROCESSING_ADDRESS_WRONG':
                                message.error('Неверный адрес');
                                setShowVerifed(false);
                                setFetching(false);
                                return;
                            case 'ASSET_UNKNOWN':
                                message.error('Не указан параметр');
                                setShowVerifed(false);
                                setFetching(false);
                                return;
                            case 'ASSET_NOT_FOUND':
                                message.error('Не найден идентификатор');
                                setShowVerifed(false);
                                setFetching(false);
                                return;
                            case 'PROCESSING_ASSET_NOT_FOUND':
                                message.error('Не верный токен');
                                setShowVerifed(false);
                                setFetching(false);
                                return;
                            case 'ROCESSING_ASSET_NOT_ACCESS':
                                message.error('Ограничен доступ');
                                setShowVerifed(false);
                                setFetching(false);
                                return;
                            case 'WALLET_WITHDRAWAL_CAPACITY_NOT_ENOUGH':
                                message.error('Сумма превышает лимит');
                                setShowVerifed(false);
                                setFetching(false);
                                return;
                            case 'WALLET_WITHDRAWAL_OPERATION_VALUE_MIN':
                                message.error('Сумма меньше минимального значения');
                                setShowVerifed(false);
                                setFetching(false);
                                return;
                            case 'WALLET_WITHDRAWAL_OPERATION_VALUE_MAX':
                                message.error('Сумма больше максимального значения');
                                setShowVerifed(false);
                                setFetching(false);
                                return;
                            case 'WALLET_OPERATION_AMOUNT_WRONG_VALUE':
                                message.error('Ошибка расчета комисии');
                                setShowVerifed(false);
                                setFetching(false);
                                return;
                            case 'WALLET_BALANCE_NOT_ENOUGH':
                                message.error('Недостаточно средств для вывода');
                                setShowVerifed(false);
                                setFetching(false);
                                return;
                            default:
                                message.error('Произошла ошибка');
                                setShowVerifed(false);
                                setFetching(false);
                                return;
                        }
                }
            });
    }

    async function validateAddress(toUser: string): Promise<boolean> {
        if (!withDrawProcessingAlow || !toUser) return false;
        const walletClient = new WalletClient(transport);

        let result = false;

        try {
            const { response } = await walletClient.validateAddress(
                { address: toUser, processingId: withDrawProcessingAlow.processingId },
                { meta: { authorization: getToken() } }
            );

            if (response.validated) {
                result = true;
            } else {
                setShowVerifed(false);
                Notification(type.error);
                setErrorMessage(t('errors.address'));
                setFetching(false);
                result = false;
            }
        } catch (error) {
            result = false;
            setShowVerifed(false);
            Notification(type.error);
            setErrorMessage(t('errors.address'));
            setFetching(false);
            console.log('error');
            console.log(error);
        }

        return result;
    }

    function validateAmount(amount: string): boolean {
        let result = false;
        if (googleAuthenticator.status !== 1 && Number(amount) > 1000) {
            setErrorMessage(t('errors.limit'));
            Notification(type.error);
            return (result = false);
        }

        if (Number(amount) > Number(withDrawProcessingAlow?.settingsWithdrawalOperationValueMax)) {
            setErrorMessage(
                t('errors.amount_len_long', {
                    amount: Number(withDrawProcessingAlow?.settingsWithdrawalOperationValueMax),
                })
            );
            Notification(type.error);
            return (result = false);
        }

        if (Number(amount) < Number(withDrawProcessingAlow?.settingsWithdrawalOperationValueMin)) {
            setErrorMessage(
                t('errors.amount_len_short', {
                    amount: Number(withDrawProcessingAlow?.settingsWithdrawalOperationValueMin),
                })
            );
            Notification(type.error);
            return (result = false);
        }
        if (Number(userWallet?.withdrawalCapacity?.available) < Number(amount)) {
            setErrorMessage(t('errors.money_small', { dop: '' }));
            Notification(type.error);
            return (result = false);
        }

        if (
            !opertionFeeFromBody &&
            googleAuthenticator.status === 1 &&
            Number(userWallet?.withdrawalCapacity?.available) -
                (Number(amount) + (Number(amount) / 100 + Number(withDrawProcessingAlow?.settingsWithdrawalFeeBase))) <
                0
        ) {
            setErrorMessage(
                t('errors.money_small', {
                    dop: `(${Number(userWallet?.withdrawalCapacity?.available).toLocaleString()} -> ${(
                        Number(userWallet?.withdrawalCapacity?.available) -
                        (Number(amount) +
                            (Number(amount) / 100 + Number(withDrawProcessingAlow?.settingsWithdrawalFeeBase)))
                    ).toLocaleString()})`,
                })
            );
            Notification(type.error);
            return (result = false);
        }

        result = true;

        return result;
    }

    function validateMEll(amount: string): boolean {
        let result = false;

        if (Number(amount) < 30000) {
            setErrorMessage(t('errors.short_mell'));
            Notification(type.error);
            return (result = false);
        }

        if (Number(userWallet?.withdrawalCapacity?.available) < Number(amount)) {
            setErrorMessage(t('errors.money_small', { dop: '' }));
            Notification(type.error);
            return (result = false);
        }

        result = true;
        return result;
    }

    useEffect(() => {
        if (errorMessage) {
            setTimeout(() => {
                setErrorMessage(null);
            }, 3200);
        }
    }, [errorMessage]);

    function closing() {
        setClose(true);
        setTimeout(() => closeBtn(), 200);
    }

    return (
        <>
            <div className="withdraw">
                <div
                    className="out"
                    onClick={closing}></div>
                <div
                    className="withdraw__dialog"
                    id={close ? 'close' : ''}>
                    {closeBtn && (
                        <span
                            className="withdraw__dialog--close-btn"
                            onClick={closing}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="8"
                                viewBox="0 0 12 8"
                                fill="none">
                                <path
                                    d="M6.01744 7.39803C5.91269 7.39852 5.8089 7.37809 5.71215 7.33793C5.61541 7.29778 5.52766 7.2387 5.45405 7.16417L0.139066 1.84919C0.0330583 1.6941 -0.0147788 1.50656 0.00399088 1.31964C0.0227606 1.13273 0.106932 0.958441 0.241659 0.827527C0.376386 0.696613 0.553015 0.617479 0.740393 0.604082C0.92777 0.590685 1.11386 0.643885 1.26584 0.754301L6.01744 5.47401L10.769 0.754301C10.9189 0.657152 11.097 0.613122 11.2748 0.629266C11.4527 0.645411 11.6199 0.720795 11.7498 0.843336C11.8797 0.965878 11.9647 1.12848 11.9912 1.30508C12.0177 1.48168 11.9841 1.66206 11.8958 1.8173L6.58083 7.13228C6.50996 7.2126 6.42344 7.2776 6.32656 7.3233C6.22968 7.369 6.12449 7.39443 6.01744 7.39803Z"
                                    fill="#506690"
                                />
                            </svg>
                        </span>
                    )}
                    <div
                        className="withdraw__dialog--content"
                        id={showVerifed ? 'showVerifed' : ''}>
                        <h1>
                            {t('wallet.withdraw.title') + ' ' + (assetId === 1 ? 'USDT' : '$MOON')}
                            {showVerifed ? (
                                <span></span>
                            ) : (
                                <span>{assetId === 1 ? t('wallet.withdraw.text1') : t('wallet.withdraw.text2')}</span>
                            )}
                        </h1>
                        {
                            <div className="withdraw__dialog--content--form">
                                <label>
                                    {t('wallet.withdraw.labeles.sum')}
                                    <div
                                        className="input"
                                        onClick={() => setOpenAmount(true)}>
                                        {Number(amountValue).toLocaleString()}
                                    </div>
                                </label>
                                <OperationFee
                                    withDrawProcessingAlow={withDrawProcessingAlow}
                                    operationFeeFromBody={opertionFeeFromBody}
                                    setOperationFeeFromBody={setOperationFeeFromBody}
                                    amountValue={amountValue}
                                    userWallet={userWallet}
                                />

                                <label>
                                    {t('wallet.withdraw.labeles.to', { network: assetId === 1 ? 'BEP20' : 'Etherium' })}
                                    <div
                                        className="input"
                                        onClick={() => setOpenToUser(true)}>
                                        {toUser}
                                    </div>
                                    {assetId === 2 && (
                                        <span
                                            style={{
                                                color: 'rgba(231, 81, 90, 1)',
                                                fontFamily: 'SF',
                                                fontSize: '12px',
                                                fontWeight: '500',
                                                lineHeight: '20px',
                                            }}>
                                            {t('mell_w')}
                                        </span>
                                    )}
                                </label>
                            </div>
                        }

                        <div className="withdraw__dialog--content--btns">
                            <Button
                                title={t('wallet.withdraw.btns.cancel')}
                                onClick={() => (showVerifed ? setShowVerifed(false) : closing())}
                            />
                            {!showVerifed && (
                                <Button
                                    disabled={!allow()}
                                    title={t('wallet.withdraw.btns.ok')}
                                    onClick={() => {
                                        if (!allow()) return;
                                        console.log('click');
                                        if (googleAuthenticator.status === 1) return setShowVerifed(true);
                                        withdraw();
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {showVerifed && (
                <IosModal
                    cancel={() => {
                        setShowVerifed(false);
                    }}
                    cancelBtnTitle={t('modals.ios.header.btns.cancel')}
                    title={t('modals.ios.header.titles.code')}>
                    <InputOTP
                        inputType="numeric"
                        type="tel"
                        inputStyle={{
                            opacity: fetching ? 0.5 : 1,
                            userSelect: 'none',
                            background: 'var(--ln-bg)',
                            border: '1px solid #5E88C7',
                            color: '#8590AC',
                            fontSize: '20px',
                            fontFamily: 'Unbounded',
                        }}
                        autoSubmit={withdraw}
                    />
                </IosModal>
            )}
            {openAmount && (
                <ControlledInput
                    close={() => setOpenAmount(false)}
                    setValue={setAmountValue}
                    placeholder={t('placeholders.withdraw')}
                    title={t('modals.ios.header.titles.withdraw')}
                    typeInput="number"
                    value={amountValue}
                    validate={assetId === 2 ? validateMEll : validateAmount}
                    errorMessgae={errorMessage}>
                    <ul className="description">
                        {errorMessage && (
                            <li
                                style={{ margin: '-5px 0 12px 0' }}
                                className="danger">
                                {errorMessage}
                            </li>
                        )}
                        {googleAuthenticator.status !== 1 && assetId !== 2 && (
                            <li>
                                <span onClick={() => navigate('/profile')}>{t('twoFA.on')} </span>
                                {', '}
                                {t('wallet.withdraw.limit')}
                            </li>
                        )}
                        {assetId === 2 && <li>{t('mell_limit')}</li>}
                    </ul>
                </ControlledInput>
            )}
            {openToUser && (
                <ControlledInput
                    close={() => setOpenToUser(false)}
                    setValue={setToUser}
                    validate={validateAddress}
                    placeholder={t('placeholders.wallet')}
                    title={t('modals.ios.header.titles.wallet')}
                    typeInput="text"
                    value={toUser}
                    errorMessgae={errorMessage}>
                    <ul
                        className="description"
                        style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                        {errorMessage && (
                            <li
                                style={{ margin: '-5px 0 12px 0' }}
                                className="danger">
                                {errorMessage}
                            </li>
                        )}
                        <li className="">
                            {t('wallet.withdraw.danger', { value: assetId === 1 ? 'BEP 20' : 'Etherium' })}
                        </li>
                    </ul>
                </ControlledInput>
            )}
        </>
    );
};

export default WithDraw;
